import { render, staticRenderFns } from "./tree-menu.vue?vue&type=template&id=5ea263d4&scoped=true&"
import script from "./tree-menu.vue?vue&type=script&lang=js&"
export * from "./tree-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea263d4",
  null
  
)

export default component.exports